import { Box, Card, Grid, Typography } from "@mui/material";
import { MdOutlineEdit, MdOutlineWatchLater } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import IMAGE from "../../../assets/images/big/abcz.png";
import { customStep, update } from "../../../slice/jobSlice";
import { useEffect } from "react";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import RestrictedIconButton from "../../../components/AnimatedIcon/RestrictedIconButton";

const ViewJobDetails = () => {
  const dispatch = useDispatch()
  const { jobData } = useSelector(state => state.job);
  const appliedAplicants = jobData?.cliniciansCount || 0;
  console.log("jobData Final Screen", jobData)
  useEffect(() => { }, [jobData])
  const { userDetails } = useSelector(state => state.user);
  console.log("userDetails", userDetails)
  return (
    <>
      <Grid container spacing={1} justifyContent="space-around" px={3} pb={18} mt={-3}>
        <Grid item lg={4}>
          <Card>
            <Grid container alignItems="center" spacing={1} justifyContent="space-around" px={3} >
              <Grid item xs={12} sm={12} display="flex" gap={3}>
                <Typography pt={2}>
                  <img src={IMAGE} alt="facilityImage" />
                </Typography>
                <Typography>
                  <Box pt={2}>
                    <Typography style={{ fontWeight: 500, fontSize: "14px", color: "#000000", opacity: "87%" }}>{userDetails?.FACILITY_NAME}</Typography>
                    <Typography style={{ fontWeight: 400, fontSize: "12px", color: "#000000", opacity: "60%" }}>{userDetails?.STREET_ADDRESS}</Typography>
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Box>
                  <Typography variant="h2" pt={2} style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{jobData.JOB_ROLE_NAME}</Typography>
                  <Typography variant="h4" pt={2} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>
                  {/* {jobData?.SERVICE_TYPE === "Recurring" ? <>
                    {jobData?.SERVICE_DURATION?.map((data) =>
                      <Box display="flex" gap={1}>
                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data?.JOB_DAY}</Typography>
                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_IN_TIME}</Typography>  <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>-</Typography>
                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_OUT_TIME}</Typography>
                      </Box>)}</> : <>

                    {jobData?.JOB_SERVICE_WITH_DAY_TIME &&
                      (<Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>
                        {jobData.JOB_SERVICE_WITH_DAY_TIME[0]?.JOB_DAY}-{jobData.JOB_SERVICE_WITH_DAY_TIME[jobData.JOB_SERVICE_WITH_DAY_TIME.length - 1]?.JOB_DAY}
                      </Typography>)}
                  </>} */}
                  {jobData?.SERVICE_TYPE === "Recurring"
                    ? jobData?.JOB_SERVICE_WITH_DAY_TIME?.map((data) =>
                      <Box display="flex" gap={1}>
                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data?.JOB_DAY}</Typography>
                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_IN_TIME}</Typography>  <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>-</Typography>
                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_OUT_TIME}</Typography>
                      </Box>
                    )

                    :
                    jobData?.JOB_SERVICE_WITH_DAY_TIME &&
                    (<Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>
                      {jobData.JOB_SERVICE_WITH_DAY_TIME[0]?.JOB_DAY}-{jobData.JOB_SERVICE_WITH_DAY_TIME[jobData.JOB_SERVICE_WITH_DAY_TIME.length - 1]?.JOB_DAY}
                    </Typography>)
                  }
                </Box>
              </Grid>
            </Grid>

            {/* <hr style={{ marginTop: "30px", color: "#000000", opacity: "60%", width: "90%", margin: "0 auto" }} /> */}
            <Box px={2}>
              <Divider sx={{ marginTop: 3, width: "100%", }} />
            </Box>

            <Box px={2} >
              <Box display="flex" justifyContent="space-between" pt={1.2}>


                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Applied Applicants</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{appliedAplicants}</Typography>
                  </Box>
                </Box>

                <Box>
                  {appliedAplicants > 0 && <Typography variant="h6" style={{ fontSize: "10px", color: "#6ebe44", opacity: "60%" }}>
                    (Editing allowed)
                  </Typography>}
                </Box>
              </Box>
              <Box display="flex" justifyContent="space-between" pt={1.2}>


                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Title</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.JOB_ROLE_NAME}</Typography>
                  </Box>
                </Box>

                <Box>
                  <Box>
                    <RestrictedIconButton
                      title="Edit Title"
                      icon={MdOutlineEdit}
                      onClick={() => {
                        dispatch(customStep(4));
                        dispatch(update({ REDIRECT: true }));
                      }}
                    />

                  </Box>
                </Box>
              </Box>


              <Box display="flex" justifyContent="space-between" pt={1.2}>
                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Speciality</Typography>
                  </Box>

                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.SPECIALTY_NAME}</Typography>
                  </Box>
                </Box>

                <Box>
                  <Box>
                    <RestrictedIconButton
                      title="Edit Speciality"
                      icon={MdOutlineEdit}
                      onClick={() => {
                        dispatch(customStep(5));
                        dispatch(update({ REDIRECT: true }));
                      }}
                    />

                  </Box>
                </Box>
              </Box>


              {jobData?.HIRING_TYPE != "Self Hire" &&
                <Box display="flex" justifyContent="space-between" pt={1.2}>
                  <Box>
                    <Box>
                      <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Staffing Solution</Typography>

                    </Box>

                    <Box>
                      <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData.STAFFING_SOLUTION}</Typography>
                    </Box>
                  </Box>

                  <Box>
                    <Box>
                      <RestrictedIconButton
                        title="Edit Staffing Solution"
                        icon={MdOutlineEdit}
                        onClick={() => {
                          dispatch(customStep(0));
                          dispatch(update({ REDIRECT: true }));
                        }}
                      />

                    </Box>
                  </Box>
                </Box>}


              <Box display="flex" justifyContent="space-between" pt={1.2}>
                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Job Type</Typography>
                  </Box>

                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData.JOB_TYPE}</Typography>
                  </Box>
                </Box>

                <Box>
                  <Box>
                    {jobData?.STAFFING_SOLUTION !== "DirectHire" &&
                      <RestrictedIconButton
                        title="Edit Job Type"
                        icon={MdOutlineEdit}
                        onClick={() => {
                          dispatch(customStep(2));
                          dispatch(update({ REDIRECT: true }));
                        }}
                      />}
                  </Box>
                </Box>
              </Box>


              <Box display="flex" justifyContent="space-between" pt={1.2}>
                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Shift Type</Typography>
                  </Box>

                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData.SERVICE_TYPE}</Typography>
                  </Box>
                </Box>

                <Box>
                  <Box>
                    <RestrictedIconButton
                      title="Edit Shift Type"
                      icon={MdOutlineEdit}
                      onClick={() => {
                        dispatch(customStep(3));
                        dispatch(update({ REDIRECT: true }));
                      }}
                    />

                  </Box>
                </Box>
              </Box>



              <Box display="flex" justifyContent="space-between" pt={1.2}>
                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Start Date</Typography>
                  </Box>

                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>
                  </Box>
                </Box>

                <Box>
                  <Box>
                    <RestrictedIconButton
                      title="Edit Start Date"
                      icon={MdOutlineEdit}
                      onClick={() => {
                        dispatch(customStep(3));
                        dispatch(update({ REDIRECT: true }));
                      }}
                    />

                  </Box>
                </Box>
              </Box>


              <Box display="flex" justifyContent="space-between" pt={1.2}>
                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Working Days</Typography>
                  </Box>

                  <Box>

                    {jobData?.SERVICE_TYPE === "Recurring"
                      ? jobData?.JOB_SERVICE_WITH_DAY_TIME?.map((data) =>
                        <Box display="flex" gap={1}>
                          <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                          <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data?.JOB_DAY}</Typography>
                          <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_IN_TIME}</Typography>  <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>-</Typography>
                          <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_OUT_TIME}</Typography>
                        </Box>
                      )

                      :
                      jobData?.JOB_SERVICE_WITH_DAY_TIME &&
                      (<Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>
                        {jobData.JOB_SERVICE_WITH_DAY_TIME[0]?.JOB_DAY}-{jobData.JOB_SERVICE_WITH_DAY_TIME[jobData.JOB_SERVICE_WITH_DAY_TIME.length - 1]?.JOB_DAY}
                      </Typography>)
                    }
                  </Box>
                </Box>

                <Box>
                  <Box>
                    <RestrictedIconButton
                      title="Edit Working Days"
                      icon={MdOutlineEdit}
                      onClick={() => {
                        dispatch(customStep(3));
                        dispatch(update({ REDIRECT: true }));
                      }}
                    />

                  </Box>
                </Box>
              </Box>

              {jobData.SERVICE_TYPE !== "Recurring" && (
                <Box display="flex" justifyContent="space-between" pt={1.2}>
                  <Box>
                    <Box>
                      <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Time</Typography>
                    </Box>
                    <Box>
                      <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.JOB_IN_TIME} - {jobData?.JOB_OUT_TIME}</Typography>
                    </Box>

                  </Box>

                  <Box>
                    <Box>
                      <RestrictedIconButton
                        title="Edit Time"
                        icon={MdOutlineEdit}
                        onClick={() => {
                          dispatch(customStep(3));
                          dispatch(update({ REDIRECT: true }));
                        }}
                      />


                    </Box>
                  </Box>
                </Box>
              )}


              <Box display="flex" justifyContent="space-between" pt={1.2}>
                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Pay</Typography>
                  </Box>

                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>${jobData.PAY_AMOUNT_FROM}-{jobData.PAY_AMOUNT_TO}/hr</Typography>
                  </Box>
                </Box>

                <Box>
                  <Box>
                    <RestrictedIconButton
                      title="Edit Pay"
                      icon={MdOutlineEdit}
                      onClick={() => {
                        dispatch(customStep(3));
                        dispatch(update({ REDIRECT: true }));
                      }}
                    />

                  </Box>
                </Box>
              </Box>

              <Box display="flex" justifyContent="space-between" pt={1.2}>
                <Box>
                  <Box>
                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Location</Typography>
                  </Box>

                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.FACILITY_LOCATION?.STREET_ADDRESS}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* End Code */}
            {/* <!----------------------------------------------------------------------------!> */}
          </Card>


        </Grid>
        <Grid item lg={8} mt={0}>
          <Card >
            <Grid container alignItems="center" spacing={1} justifyContent="space-around" p={3} pb={3}>
              <Grid item xs={12} sm={12} display="flex" justifyContent="space-between">
                <Typography variant="h3" style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>
                  Job Description
                </Typography>
                <Typography>
                  <Tooltip title="Edit JobDescription">
                    <IconButton>
                      <MdOutlineEdit style={{
                        // color: 'linear-gradient(to right,#4eb3e8,#6ebe44)',
                        color: "#6ebe44",
                        cursor: "pointer", fontSize: "20px"
                      }} onClick={() => {
                        dispatch(customStep(7))
                        dispatch(update({ "REDIRECT": true }))

                      }} />
                    </IconButton>
                  </Tooltip>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography id="delete-modal-title" variant="h6" component="h2" style={{ fontWeight: 400, fontSize: "16px", color: "#000000", opacity: "60%" }}>
                  <div
                    dangerouslySetInnerHTML={{ __html: jobData.JOB_DESCRIPION }}
                  />
                </Typography >
              </Grid>
              <Grid item xs={12} sm={12} mt={3} >

                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h3" style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>
                    Responsibilities
                  </Typography>

                  <Typography>
                    <Tooltip title="Edit Responsibilities">
                      <IconButton>
                        <MdOutlineEdit style={{
                          // color: 'linear-gradient(to right,#4eb3e8,#6ebe44)', 
                          color: "#6ebe44",
                          cursor: "pointer", fontSize: "20px"
                        }} onClick={() => {
                          dispatch(customStep(6))
                          dispatch(update({ "REDIRECT": true }))

                        }} />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                </Box>


                <Typography px={0.7} pt={1}>
                  <div
                    dangerouslySetInnerHTML={{ __html: jobData.JOB_RESPONSIBILITY }}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                {/* <Typography id="delete-modal-title"  variant="h5" component="h2">
                           {jobData?.JOB_RESPONSIBILITY}
                    </Typography> */}
              </Grid>
            </Grid>
          </Card>


        </Grid>


      </Grid>



    </>


  )
};

export default ViewJobDetails;



